<template>
    <div class="px-0">
        <LessonListContent
            v-for="content in contents"
            :key="content.id"
            :content="content"
            :selectContentId="loadedContent.id_lesson_content ? loadedContent.id_lesson_content : currentContentId"
            @contentClicked="setContent($event)"
        />
        <template v-if="listCurrentPage < listLastPage">
            <BaseButton
                @click="loadNextPage"
                block
                type="primary"
            >{{$t('common.load_more_content')}}</BaseButton>
        </template>
    </div>
</template>

<script>
import BaseButton from "../../argon/components/BaseButton";
import Collapse from "../../argon/components/Collapse/Collapse";
import CollapseItem from "../../argon/components/Collapse/CollapseItem";

import LessonListContent from "./LessonListContent";

export default {
    name: "LessonMainContent",

    components: {
        BaseButton,
        LessonListContent,
        Collapse,
        CollapseItem
    },

    props: {
        contents: {
            type: Array,
            required: true
        },
        currentContentId: Number,
        listLastPage: Number,
        listCurrentPage: Number
    },

    data() {
        return {
            firstLoad: true
        };
    },

    watch: {
        contents(value) {
            if (this.firstLoad) {
                if (value.length > 0) {
                    this.setContent(value[0]);
                    this.firstLoad = false;
                }
            }
        }
    },

    methods: {
        setContent(event) {
            this.$emit("setContent", event);
        },
        loadNextPage() {
            this.$emit("loadNextPage");
        }
    },

    computed: {
        loadedContent() {
            return this.$store.getters.LOADED_CONTENT;
        },
    }
};
</script>

<style>
</style>